import AdminLayout from "../../layouts/AdminLayout";
import Profile from "../../components/Profile";

const AdminDashboard = () => {
  return (
    <AdminLayout>
      admin dashboard
    </AdminLayout>
  );
};

export default AdminDashboard;
